import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { MapArea, SelectedFilters } from './filter-spaces-models';

import * as _ from 'lodash';

@Injectable({
    providedIn: 'root'
})
export class FilterSpacesService {
    // Which filteras and indications that currently are selected
    private _defaultSelectedValues: SelectedFilters = {
        areaSelection: MapArea.WORLD,
        toggleableSelectionOptions: {
            potentialTimingPointsOnly: false
        }
    };

    private _selectedValues$ = new BehaviorSubject<SelectedFilters>(this._defaultSelectedValues);
    public selectedValues$ = this._selectedValues$.asObservable();
    public get selectedFilterValue(): SelectedFilters {
        return this._selectedValues$.getValue();
    }

    private _filterIsApplied$ = new BehaviorSubject<number>(0);
    public filterIsApplied$ = this._filterIsApplied$.asObservable();

    private _ngUnsubscribe$ = new Subject<void>();

    constructor(
    ) {
    }

    private _updateSelected(newValue: SelectedFilters) {
        this._selectedValues$.next(newValue);
        this._updateFilterIsApplied(newValue);
    }

    private _updateFilterIsApplied(newValue: SelectedFilters) {
        let filterAppliedValues = 0;
        filterAppliedValues += newValue.areaSelection !== MapArea.WORLD ? 1 : 0;

        for (const key of Object.keys(newValue.toggleableSelectionOptions)) {
            const val = newValue.toggleableSelectionOptions[key];
            if (val) {
                filterAppliedValues += 1;
            }
        }

        const prevFilterAppliedValue = this._filterIsApplied$.value;
        if (prevFilterAppliedValue !== filterAppliedValues) {
            this._filterIsApplied$.next(filterAppliedValues);
        }
    }

    public selectMapArea(mapArea: MapArea) {
        const newSelected: SelectedFilters = {
            ...this.selectedFilterValue,
            areaSelection: mapArea
        };
        this._updateSelected(newSelected);
    }

    public selectTimingStopsOnly(isTimingStopsOnly: boolean) {
        const newSelected: SelectedFilters = {
            ...this.selectedFilterValue,
            toggleableSelectionOptions: {
                ...this.selectedFilterValue.toggleableSelectionOptions,
                potentialTimingPointsOnly: isTimingStopsOnly
            }
        };

        this._updateSelected(newSelected);
    }

    public toggleSelectionOption(checked: boolean, selectionOptionKey: string) {
        if (this.selectedFilterValue.toggleableSelectionOptions[selectionOptionKey] === undefined) {
            return;
        }

        const newSelected: SelectedFilters = {
            ...this.selectedFilterValue,
            toggleableSelectionOptions: {
                ...this.selectedFilterValue.toggleableSelectionOptions,
                [selectionOptionKey]: checked
            }
        };

        this._updateSelected(newSelected);
    }

    public clearFilterSelections() {
        const defaulFilter = this._defaultSelectedValues;
        defaulFilter.areaSelection = MapArea.WORLD;
        this._updateSelected(defaulFilter);
    }
}
